<template>
  <div class="absolute top-0 right-0 bottom-0 left-0 z-0">
    <l-map
        class="z-0"
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
        :attributionControl="false"
        :attribution="null"
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate"
        ref="map"
    >
      <l-tile-layer
          :options="{}"
          :url="url"
          @loading="loading = true"
          @load="stopLoading"
      />

      <l-tile-layer
          v-if="$root.print.showCityNames"
          :options="{}"
          :url="cityNamesLayerUrl"
      />
    </l-map>

<!--    <div class="absolute inset-0 z-50 flex items-center justify-center pointer-events-none" v-if="loading">-->
<!--      <div class="rounded-full bg-black bg-opacity-50 p-8 flex items-center justify-center">-->
<!--        <div class="lds-roller">-->
<!--          <div></div>-->
<!--          <div></div>-->
<!--          <div></div>-->
<!--          <div></div>-->
<!--          <div></div>-->
<!--          <div></div>-->
<!--          <div></div>-->
<!--          <div></div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
// import {LMap} from 'vue2-leaflet';

import {LMap, LTileLayer} from 'vue2-leaflet';
// const LMap = () => import('vue2-leaflet/src/components/LMap')
// const LTileLayer = () => import('vue2-leaflet/src/components/LTileLayer')
// const LTileLayer = () => import("vue2-leaflet/src/components/LTileLayer")

export default {
  name: "MapLayer",
  components: {
    'l-map': LMap,
    'l-tile-layer': LTileLayer
  },

  mounted() {
    window.bus.$on('resize', () => {
      console.log('resize in maplayer');
      this.$refs.map.mapObject.invalidateSize();
    })
  },

  data() {
    return {
      loading: false,
      mapOptions: {
        zoomControl: false
      },
    };
  },

  computed: {
    url() {
      return `https://kaartenzijncool.printmijnstad.nl/${this.$root.print.layers}/{z}/{x}/{y}${L.Browser.retina ? '@2x' : ''}.png`;
    },
    cityNamesLayerUrl() {
      return `https://kaartenzijncool.printmijnstad.nl/labels_modern/{z}/{x}/{y}${L.Browser.retina ? '@2x' : ''}.png`;
    },
    center() {
      return window.L.latLng(this.$root.print.lat, this.$root.print.lng);
    },
    zoom() {
      return parseInt(this.$root.print.zoom);
    },
  },
  methods: {
    zoomUpdate(zoom) {
      this.$root.print.zoom = zoom;
    },
    centerUpdate(center) {
      this.$root.print.lat = center.lat;
      this.$root.print.lng = center.lng;
    },
    stopLoading() {
      this.loading = false;
      setTimeout(() => {
        this.$nextTick(() => {
          this.loading = false
        });
      }, 1500);
    }
  },

  watch: {
    '$root.posterSize': {
      handler: function (after, before) {
        setTimeout(() => {
          this.$nextTick(() => {
            window.bus.$emit('resize');

            this.$refs.map.mapObject.invalidateSize();

          });
        }, 200);

        this.$refs.map.mapObject.invalidateSize();
      },
      deep: true,
    },
  }
};
</script>

<style lang="scss" scoped>
#root {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.lds-roller {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}

.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #fff;
  margin: -4px 0 0 -4px;
}

.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}

.lds-roller div:nth-child(1):after {
  top: 63px;
  left: 63px;
}

.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}

.lds-roller div:nth-child(2):after {
  top: 68px;
  left: 56px;
}

.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}

.lds-roller div:nth-child(3):after {
  top: 71px;
  left: 48px;
}

.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}

.lds-roller div:nth-child(4):after {
  top: 72px;
  left: 40px;
}

.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}

.lds-roller div:nth-child(5):after {
  top: 71px;
  left: 32px;
}

.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}

.lds-roller div:nth-child(6):after {
  top: 68px;
  left: 24px;
}

.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}

.lds-roller div:nth-child(7):after {
  top: 63px;
  left: 17px;
}

.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}

.lds-roller div:nth-child(8):after {
  top: 56px;
  left: 12px;
}

@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>